/* eslint-disable */

import React, { useContext } from 'react';
import ResourceBrowserContext from './ResourceBrowserContext';
import { Text } from 'grommet';
import {
  StyledFilterList,
  StyledPillsList,
  StyledPill,
} from './ResourceBrowserFilterListStyle';

const FilterPill = ({ children, ...rest }) => (
  <StyledPill {...rest}>
    <Text>{children}</Text>
    <div />
  </StyledPill>
);

const ResourceBrowserPillsList = () => {
  const { filters, setFilters } = useContext(ResourceBrowserContext);

  // map through the filters object by key
  // and append the group key to each filter title/slug pair
  const activeFilters = Object.keys(filters)
    .map((key) => filters[key].map((filter) => ({ ...filter, groupSlug: key })))
    .flat();

  const handlePillClick = ({ slug, groupSlug }) => {
    setFilters({
      ...filters,
      [groupSlug]: filters[groupSlug].filter((f) => f.slug !== slug),
    });
  };

  return (
    <StyledFilterList>
      <div>
        {activeFilters.length !== 0 && (
          <StyledPillsList>
            {activeFilters.map((filter, index) => (
              <div key={index}>
                <FilterPill onClick={() => handlePillClick(filter)}>
                  {filter.title}
                </FilterPill>
              </div>
            ))}
          </StyledPillsList>
        )}
      </div>
    </StyledFilterList>
  );
};

export default ResourceBrowserPillsList;
